module.exports = __webpack_public_path__ + "static/media/spain.36938bbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/spain.svg
// module id = 1416
// module chunks = 1